import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const MicExternalOnIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"mic_external_on"} ref={ref}/>
});

MicExternalOnIcon.displayName = "MicExternalOnIcon";
